import { render, staticRenderFns } from "./ZoInfo.vue?vue&type=template&id=36640f44&scoped=true&"
import script from "./ZoInfo.vue?vue&type=script&lang=js&"
export * from "./ZoInfo.vue?vue&type=script&lang=js&"
import style0 from "./ZoInfo.vue?vue&type=style&index=0&id=36640f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36640f44",
  null
  
)

export default component.exports